<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Редактировать квартиру
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'apartment-details', params: { apartment_id: apartment.id }}">← Назад к Деталям квартиры</router-link>
    </div>

    <div class="text-right">
      <a v-if="apartment.id" class="red" href="#" @click.prevent="deleteApartment">удалить квартиру</a>
    </div>

    <apartment-edit-form
      :apartment="apartment"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import { getApartment, deleteApartment } from '@/services/apartment.service'
import apartmentEditForm from '@/components/forms/apartment/ApartmentEditForm'

export default {
  name: 'apartment-edit',
  components: { apartmentEditForm },
  data () {
    return {
      apartment: {
        id: null,
        number: '',
        block: ''
      },

      errors: {
        apartment: {
          id: [],
          number: [],
          block: []
        },
        non_field_errors: []
      }
    }
  },
  mounted () {
    if (this.$route.params.apartment_id !== undefined) {
      this.apartment.id = this.$route.params.apartment_id

      getApartment(this.apartment.id).then((response) => {
        this.apartment = response.data
      })
    }
  },
  methods: {
    deleteApartment () {
      deleteApartment(this.apartment.id).then((response) => {
        this.showMsg('Квартира была удалена!', 'success', 'Успешно')
        this.$router.push({ name: 'block-details', params: { block_id: this.$route.params.block_id } })
        return true
      }).catch(err => {
        console.log(err)
        this.showMsg('Квартира была удалена!', 'success', 'Успешно')
        this.$router.push({ name: 'block-details', params: { block_id: this.$route.params.block_id } })
        return true
      })
    },
    handleAfter (success) {
      console.log(success)
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ApartmentEdit.vue?39aac63c